import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';


import PackagesPage from 'components/packages/PackagesPage';
import LoginPage from 'components/auth/LoginPage';
import PackageDetailPage from 'components/packages/PackageDetailPage';
import {ConnectedRouter} from 'react-router-redux'

import {Provider} from 'react-redux'
import {history} from './configureStore';
import configureStore from './configureStore';

import {Switch} from 'react-router-dom';
import Route from './AuthRoute';

import Bar from './components/Bar';

import ActionButton from './components/ActionButton';
import {PersistGate} from 'redux-persist/lib/integration/react'
import muiTheme from 'theme';
import LearningPage from "components/learning/LearningPage";
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n';
import $ from 'jquery';
const {persistor, store} = configureStore();

const onBeforeLift = () => {
    // take some action before the gate lifts
};

class App extends Component {

    componentDidMount() {
        $('html').removeClass('loading')
    }

    render() {
        return (
            <MuiThemeProvider muiTheme={muiTheme}>
                <I18nextProvider i18n={i18n}>
                    <Provider store={store}>
                        <PersistGate
                            loading={<CircularProgress/>}
                            onBeforeLift={onBeforeLift}
                            persistor={persistor}>
                            <ConnectedRouter history={history}>
                                <div className="App">
                                    <div className={"appContainer"}>
                                        <Bar/>
                                        <div className={"pageSection"} style={{padding: '75px 40px 40px 40px'}}>
                                            <Switch>
                                                <Route exact path="/" component={PackagesPage}/>
                                                <Route exact path="/package/:packageSlug/" component={PackageDetailPage}/>
                                                <Route exact path="/login/" component={LoginPage}/>
                                                <Route exact path="/learning/" component={LearningPage}/>

                                            </Switch>
                                        </div>
                                        <ActionButton/>
                                    </div>
                                </div>
                            </ConnectedRouter>
                        </PersistGate>
                    </Provider>
                </I18nextProvider>
            </MuiThemeProvider>

        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js